import { render } from "./CountView.vue?vue&type=template&id=198a89c7"
import script from "./CountView.vue?vue&type=script&lang=js"
export * from "./CountView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__